<template>
    <div class="index-home">
        <div class="search-bar-container">
    <!-- 顶部头部 -->
            <div class="header-top">
            <div class="header-left">海尔精选商城</div>
            <div class="header-right">
                <span>分期免息</span>
                <span class="divider">|</span>
                <span>品牌直供</span>
            </div>
            </div>
            
            <!-- 搜索区域 -->
            <div class="search-section">
            <div class="search-wrapper" @click="goSearch">
                <span class="search-icon">🔍</span>
                <input 
                type="text" 
                class="search-input"
                placeholder="搜索:海尔风扇 / 公牛插排 / 九阳电饭煲"
                v-model="searchText"
                @keyup.enter="handleSearch"
                />
            </div>
            <div class="cart-icon">🛒</div>
            </div>
            
            <!-- 积分信息 -->
            <!-- <div class="points-section">
            <div class="points-left">
                <div class="points-label">我的积分</div>
                <div class="points-value">86,200</div>
            </div>
            <div class="points-right">
                <span class="points-link">签到领积分</span>
                <span class="points-divider"></span>
                <span class="points-link">积分记录</span>
            </div>
            </div> -->
        </div>
        <!-- <Banner /> -->
        <!-- <Category @category-click="handleCategoryClick" /> -->
        <div v-for="item in homeBanner" :key="item.id" class="banner-item" @click="handleBannerClick(item)">
          <img :src="item.pic" alt="" style="width: 100%;">
        </div>
        <!-- <div style="margin-top: 0.2rem;" @click="goCart">
          <img src="https://bank.giftoceanmall.com/e7c2c20260602172701664.png" alt="" style="width: 100%;">
        </div> -->
        <!-- <ActivityBanner /> -->
        <!-- <BrandWall @brand-click="handleBrandClick" /> -->
        <ProductZone @product-click="handleProductClick" />
        <div style="height:1.5rem;"></div>
    </div>
  
</template>

<script>
import Banner from '@components/Banner.vue'
import Category from '@components/Category.vue'
import ActivityBanner from '@components/ActivityBanner.vue' 
import BrandWall from '@components/BrandWall.vue'
import ProductZone from '@components/ProductZone.vue'
import { getHomeData, getShare, follow } from "@api/public";
export default {
    components: {
        Banner,
        Category,
        ActivityBanner,
        BrandWall,
        ProductZone
    },
  name: 'index',
  data() {
    return {
      searchText: '',
      homeBanner: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      getHomeData().then(res => {
       
        this.homeBanner = res.data.banner
        console.log(this.homeBanner)
      })
    },
    goCart() {
      this.$router.push({ path: '/goods_collection_list/21' })
    },
    handleBannerClick(item) {
      console.log('点击banner:', item.name)
      // 跳转到对应banner页面
      this.$router.push({ path: item.url, query: { name: item.name } })
    },
    handleProductClick(product) {
      console.log('点击商品:', product.name)
      // 跳转到对应详情页面
      this.$router.push({ path: '/product', query: { name: product.name } })
    },
    handleCategoryClick(item) {
      console.log('点击分类:', item.name)
      // 跳转到对应分类页面b
      this.$router.push({ path: '/category', query: { name: item.name } })
    },
    handleBrandClick(item) {
      console.log('点击品牌:', item.name)
      // 跳转到对应品牌页面
      this.$router.push({ path: '/brand', query: { name: item.name } })
    },
    handleSearch() {
      const keyword = this.searchText.trim()
      if (keyword) {
        this.$emit('search', keyword)
      }
    },
    goSearch() {
      this.$router.push({ path: '/search', query: { keyword: this.searchText } })
    },
  }
}
</script>

<style lang="scss" scoped>
.search-bar-container {
  background: linear-gradient(180deg, #f6f3ed 0%, #fff 100%);
  padding-bottom: 0.3rem;
//   position: fixed;
//   top: .3rem;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0.3rem;
  padding-top: calc(0.25rem + env(safe-area-inset-top));
  
  .header-left {
    color: #14233b;
    font-size: 0.32rem;
    font-weight: bold;
  }
  
  .header-right {
    display: flex;
    align-items: center;
    color: #14233b;
    font-size: 0.22rem;
    
    .divider {
      margin: 0 0.15rem;
      opacity: 0.6;
    }
  }
}

.search-section {
  display: flex;
  align-items: center;
  padding: 0 0.3rem;
  gap: 0.2rem;
  
  .search-wrapper {
    flex: 1;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 0.5rem;
    padding: 0.25rem 0.3rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .search-icon {
    font-size: 0.3rem;
    margin-right: 0.2rem;
    opacity: 0.5;
  }
  
  .search-input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 0.26rem;
    background: transparent;
    
    &::placeholder {
      color: #999;
      font-size: 0.24rem;
    }
  }
  
  .cart-icon {
    width: 0.8rem;
    height: 0.8rem;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.35rem;
  }
}

.points-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem 0.3rem 0;
  
  .points-left {
    display: flex;
    flex-direction: column;
    
    .points-label {
      color: rgba(255, 255, 255, 0.8);
      font-size: 0.22rem;
      margin-bottom: 0.05rem;
    }
    
    .points-value {
      color: #fff;
      font-size: 0.4rem;
      font-weight: bold;
    }
  }
  
  .points-right {
    display: flex;
    align-items: center;
    
    .points-link {
      color: rgba(255, 255, 255, 0.9);
      font-size: 0.24rem;
    }
    
    .points-divider {
      width: 1px;
      height: 0.3rem;
      background: rgba(255, 255, 255, 0.3);
      margin: 0 0.3rem;
    }
  }
}

/* 移动端适配 */
@media screen and (max-width: 480px) {
  .header-top {
    padding: 0.2rem 0.25rem;
    padding-top: calc(0.2rem + env(safe-area-inset-top));
    
    .header-left {
      font-size: 0.28rem;
    }
    
    .header-right {
      font-size: 0.2rem;
    }
  }
  
  .search-section {
    padding: 0 0.25rem;
    gap: 0.15rem;
    
    .search-wrapper {
      padding: 0.22rem 0.25rem;
    }
    
    .search-input {
      font-size: 0.24rem;
      
      &::placeholder {
        font-size: 0.22rem;
      }
    }
    
    .cart-icon {
      width: 0.7rem;
      height: 0.7rem;
      font-size: 0.3rem;
    }
  }
  
  .points-section {
    padding: 0.25rem 0.25rem 0;
    
    .points-label {
      font-size: 0.2rem;
    }
    
    .points-value {
      font-size: 0.35rem;
    }
    
    .points-link {
      font-size: 0.22rem;
    }
  }
}
.index-home{
  background-color: #f6f3ed;
}

</style>